module.exports = !require('../internals/fails')(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/theming/~/core-js/internals/freezing.js
// module id = 360
// module chunks = 168707334958949